import { NavigationTab } from 'shared/model';

import { AddTariffButtonLink } from './buttons';

export const TABS: Array<NavigationTab> = [
  {
    key: 'tariffs',
    path: '',
    label: 'Список тарифов',
    buttons: [
      {
        element: <AddTariffButtonLink />,
        controller: 'ChargeTariff',
        right: 'Write',
      },
    ],
  },
];
